var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vw-100 min-vw-100 vh-100 min-vh-100 p-0 m-0"},[_c('notifications',{attrs:{"position":"bottom left"}}),_c('LoginDialog'),_c('LoadingDialog'),_c('MessageDialog'),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }